module.exports = __webpack_public_path__ + "fonts/jlishu.094a0448.ttf";